import { useContext, useEffect, useState } from "react";
import { SchoolListType } from "utils/interfaces";
import { LoadingDots } from "utils/loadingAnimation";
import EmptyViewPopUp from "../common/EmptyViewPopUp";
import SelectSchoolCard from "../common/ClassesCardsList/cards/SelectSchoolCard";
import { getCollectionRequest } from "services/apiRequests";
import { MainContext } from "components/utils/Contexts";
import { logoutFunction } from "services/authRequests";

interface SelectSchoolListProps {
  setPopUpState: React.Dispatch<React.SetStateAction<"main" | "select-school">>;
}

const SelectSchoolList: React.FC<SelectSchoolListProps> = ({
  setPopUpState,
}) => {
  // States definition
  const [data, setData] = useState<SchoolListType[]>([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  // Get the context parameters
  const { setContextSchool } = useContext(MainContext);

  /**
   * Function to load the data
   */
  const getData = async () => {
    // First of all, start the animation
    setIsLoadingData(true);

    // Get request
    const response = await getCollectionRequest("/api/organisations");

    // Check if the response is successful
    if (!response.successful) {
      // Check if it's not successful because of a token expiration
      if (response.logout) {
        // alert(response.message);
        return await logoutFunction();
      }

      return [];
    }

    // Get the data
    const data = response.content;

    return data;
  };

  /**
   * Load class data when init
   */
  useEffect(() => {
    // Get the data
    getData().then((data) => {
      // Set the data
      setData(data);

      // Stop the animation
      setIsLoadingData(false);
    });
  }, []);

  /**
   * Function used to control the select behaviour
   * @param school
   */
  const selectAction = (school: SchoolListType) => {
    // Set the context school
    setContextSchool(school);
    // And go to the main view
    setPopUpState("main");
  };

  return (
    <div className="w-full max-h-[70vh] grow shrink justify-start items-start gap-[5px] inline-flex overflow-y-auto pop-up-scrollbar">
      <div className="w-full h-fit self-stretch flex-col justify-start items-start gap-4 inline-flex">
        {data.length > 0 ? (
          data.map((school: SchoolListType, index: number) => (
            <SelectSchoolCard
              key={index}
              school={school}
              selectAction={selectAction}
            />
          ))
        ) : !isLoadingData ? (
          <EmptyViewPopUp />
        ) : (
          <div className="w-full h-[50vh] flex justify-center items-center">
            <LoadingDots bgColor="bg-neutral-300" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectSchoolList;
